module.exports = __webpack_public_path__ + "static/media/pg.d2ad1883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pg.svg
// module id = 221
// module chunks = 0